<template>
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Arrow" fill-rule="evenodd" clip-rule="evenodd"
            d="M0.536696 7.73965C0.201961 7.39252 0.201961 6.8297 0.536696 6.48257L6.5367 0.260348C6.87143 -0.0867843 7.41415 -0.0867843 7.74888 0.260348L13.7489 6.48257C14.0836 6.8297 14.0836 7.39252 13.7489 7.73965C13.4141 8.08678 12.8714 8.08678 12.5367 7.73965L7.14279 2.14597L1.74888 7.73965C1.41414 8.08678 0.871431 8.08678 0.536696 7.73965Z"
            fill="#133459" />
    </svg>
</template>